// extracted by mini-css-extract-plugin
module.exports = {"block":"Block_block__YhpDz","noMargin":"Block_noMargin__RPq5X","shops-on-map":"Block_shops-on-map__HmhGR","load":"Block_load__dGkjO"};